import EducationHead from '@/components/EducationHead'
import HaveQuestions from '@/components/HaveQuestions'
import { usePage } from '@/hooks'
import { houseWithScheme } from '@/images'
import React from 'react'
import Contests from '@/components/Contests'
import LifeHacks from './components/LifeHacks'
import Quizzes from './components/Quizzes'
import SuccessStories from '@/components/SuccessStories'
import WhatToRead from '../RecommendToKnow/components/WhatToRead'
import useSWR from 'swr'
import { api } from '@/api'
import LessonsSlider from '../RecommendToKnow/components/LessonsSlider'
import { useLocation } from 'react-router-dom'

const LiveLikeAHost = (): React.ReactElement => {
  const page = usePage()
  const { data: lessons } = useSWR(
    { url: 'lessons', page_size: 1000 },
    api.getLessons
  )
  const location = useLocation()

  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  return (
    <>
      <EducationHead
        title={object.title}
        backLink={config.education}
        backLinkTitle='Обучение'
        image={houseWithScheme}
        content={object.detail}
      />

      <LifeHacks />

      <WhatToRead role='student' />

      <LessonsSlider
        lessons={lessons?.results}
        prefix='LiveLikeAHost'
        backLink={location.pathname}
        backTitle={object.title}
      />

      <Quizzes />

      <Contests />

      <SuccessStories />

      <HaveQuestions />
    </>
  )
}

export default LiveLikeAHost
